var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.9 12.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m8.1 0a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m8.1 0a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2"
})));
export default SvgMoreHorizontal;